import React from 'react';
import Pages from './basic_page';



class Parts extends Pages {
    render() {
        return (
    <>
        <h1 className='des_part'>
            Parts
        </h1>
        <div className='pageholder'>
            <div className='leftmenu'>
                <div>Parts</div>
                <button onClick={() => this.scroll(this.firstRef)}>New parts</button>
                <button onClick={() => this.scroll(this.secondRef)}>Current parts</button>
			</div>
            
            <div className='righttext'>
              <div className='P1' >
              <div className='text_wrap'>
                
                <div>
                  <p>Since our project comes from serval different designs, the parts that we built were supported by a variety of methods. Firstly, Parts in our project are all around the hole design, including Secretory system, Evolvr system and so on.</p>
                  <p>Then you can see, we built our parts by many different ways shown below: molecular cloning, synthesis, directly provided by our instructors, collaboration.</p>
                  <p>And we also used some current parts as our subparts in the project, every basic parts made an effective combination with each other, took the important role in our project.</p>


                </div>
                </div>
                </div>
                <div className='P2' ref={this.firstRef}>
                <div className='text_wrap'>
                        <h4>New Parts Table</h4>
                        <div className='img_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/new-parts.png'  alt='New Parts Table'/>	
                        </div>		
                </div>
                </div>
				       <div className='P3' ref={this.secondRef}>
				      <div className='text_wrap'>
                        <h4>Current Parts Table </h4>
                        <div className='img_wrap'>
                        <img src='https://static.igem.wiki/teams/4298/wiki/current-parts.png'  alt='New Parts Table'/>	
                        </div>		
                </div>

				</div>
            </div>
		</div>
    </>

  );
    }
};

export default Parts;
